import React, { useRef, useState } from 'react'
import FormCreator from '../../../components/finalForms/FormCreator';

import { multiRowGroupFormConfig } from './config/multiRowGroupFormConfig.data';
import Buttons from '../../../components/ui/button/Buttons';

const MultiRowGroupFormPage = () => {

    const userRef = useRef();
    const [userForm] = useState(multiRowGroupFormConfig);

    const handleSave = () => {
        const formData = userRef.current.getFormData();

        if (formData) {
            // //console.log(formData);
        }
    }

    return (
        <>
            <div className='page-title'>
                <h3>Row Group Form Creator</h3>
            </div>
            <div className='row multi-row-form-page'>
                <FormCreator
                    config={userForm}
                    ref={userRef}
                    key={false}
                />
            </div>
            <Buttons
                isLoading={false}
                textWithIcon={false}
                buttonText='Save'
                titleText="Save"
                buttonTypeClassName={'btn theme-btn'}
                onClick={handleSave}
            />
        </>
    )
}

export default MultiRowGroupFormPage